import styled from 'styled-components';
import Icon from '../../Icon/Icon';
import {basicColor, font, radius} from '../../../../../styles/template';

export const CheckIcon = styled(Icon)`
    & .colorFill {
      fill: ${basicColor.white};
    }
`
export const Hidden = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`

export const StyledCheckbox = styled.div`
    display: inline-flex;
    justify-self: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: ${radius.normal};
    transition: all 150ms;
    background: ${props => (props.checked ? basicColor.primary : ({ theme }) => theme.color.Item)};
    box-shadow: ${props => (props.checked ? ({ theme }) => theme.boxShadow.Normal : 'none')};
    ${CheckIcon} {
      visibility: ${props => (props.checked ? 'visible' : 'hidden')}
    }
`

export const Label = styled.label`
    cursor: pointer;
    display: flex;
    align-items: center;
    width: fit-content;
`;

export const LabelText = styled.div`
    padding-left: 2rem;
    ${font.basicBoldS};
    user-select: none;
    
    &.active {
         color: ${({ theme }) => theme.color.Text};
    }
`;